import React from "react";
import InputText from "../../../common/Input/InputText";
import Select from "react-select";
import styles from "../editLabReport.module.scss";

const AboutGroupTestProfile = ({
  item,
  testData,
  lowRange,
  highRange,
  referenceRange,
  handleTestProfileChange,
}) => {
  const positiveNegativeOptions = [
    { value: "Positive", label: "Positive" },
    { value: "Negative", label: "Negative" },
  ];
  const yesNoOptions = [
    { value: "No", label: "No" },
    { value: "Yes", label: "Yes" },
  ];
  return (
    <>
    <h4 className="mb-4">Name : {item?.testName}</h4>
    <div className={styles.testAndProfileWrapper}>
      {/* Category */}
      <div className={styles["inputWrapper"]}>
        <div className="form-group">
          <InputText
            value={item?.category?.categoryName || ""}
            label="Category"
            readOnly={true}
          />
        </div>
      </div>
      {/* method */}
      <div className={styles["inputWrapper"]}>
        <div className="form-group">
          <InputText
            value={item?.testMethod?.name}
            readOnly={true}
            label="Method"
          />
        </div>
      </div>
      {/* Value */}
      <div className={styles["inputWrapper"]}>
        <div className="form-group">
          <InputText
            name="value"
            value={testData?.value || ""}
            label="Value"
            onChange={(e) => handleTestProfileChange(e, "value", item._id)}
          />
        </div>
      </div>
      {/* NABL */}
      <div className={styles["inputWrapper"]}>
        <div className="form-group">
          <label className="col-form-label">Is NABL Approved</label>

          <Select
            name="isNABL"
            value={
              yesNoOptions.find(
                (option) => option.value === testData?.isNABL,
              ) || yesNoOptions[0]
            }
            onChange={(e) => handleTestProfileChange(e, "isNABL", item._id)}
            options={yesNoOptions}
          />
        </div>
      </div>
      {/* Low Value */}
      <div className={styles.inputWrapper}>
        <div className="form-group">
          <InputText readOnly={true} label="Low Value" value={lowRange ?? ""} />
        </div>
      </div>

        {/* High Value */}
        <div className={styles["inputWrapper"]}>
          <div className="form-group">
            <InputText
              readOnly={true}
              label="High Value"
              value={highRange ?? ""}
            />
          </div>
        </div>

        {/* Reference Range */}
        <div className={styles["inputWrapper"]}>
          <div className="form-group">
            <InputText
              value={referenceRange ?? ""}
              label="Reference Range"
              readOnly={true}
            />
          </div>
        </div>
      </div>

      {/* RH Type + Positive/Negative - NEXT ROW */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          // gap: "20px",
          width: "100%",
          marginTop: "20px",
        }}
      >
        {/* RH Type + Positive/Negative */}
        <div
          style={{
            display: "flex",
            gridTemplateColumns: "1fr 1fr",
            width: "40%",
            columnGap: "20px",
            alignItems: "end",
            boxSizing: "border-box",
          }}
        >
          {/* RH Type */}
          <div style={{width: "40%",minWidth: 0, }}>
            <div className="form-group">
              <InputText
                name="rhType"
                label="RH Type"
                placeholder="RhType"
                readOnly={true}
              />
            </div>
          </div>
          {/* Positive / Negative */}
          <div style={{width: "40%",minWidth: 0,}}>
            <div className="form-group">
          <Select
            name="rhType"
                placeholder="Positive / Negative"
                value={
                  testData?.rhType
                    ? {
                        value: testData.rhType,
                        label: testData.rhType,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  handleTestProfileChange(selectedOption, "rhType", item._id)
                }
                options={positiveNegativeOptions}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutGroupTestProfile;
